module.exports = __webpack_public_path__ + "static/touchpoint-d4c9a97de508e34758f5b2d7d3321c26.png";